import { ITableFiltersObject } from "@monorepo/utils/src/store/types/tableFiltersObject";
import { formDateFilter } from "@monorepo/utils/src/api/convertFiltersToApi";

export const convertFiltersCustomToApi = (
  resultFilters: ITableFiltersObject & { fieldFilters: { creationDateFrom?: string; creationDateTo?: string; status?: string } }
): void => {
  formDateFilter(resultFilters, "date");
  formDateFilter(resultFilters, "time");
};
